module.exports = __webpack_public_path__ + "static/media/loader.5119920c.svg";